import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Tag from '../../commons/tags';
import { findTranslation } from '../../../../infrastructure/i18n/findTranslation';
import { getUrlLocale } from '../../../../utils/getUrlLocale';
const TagsGroup = ({ tags }) => {
    return (_jsx(_Fragment, { children: tags.map((tag) => {
            if (tag.translate && tag.translate.length > 0) {
                // WI #8320 — Same `.includes()` bug pattern as the other pickers.
                // Replace with `findTranslation` keyed off the URL locale so
                // tag labels match the URL language regardless of the country
                // selector state.
                const translation = findTranslation(tag.translate, getUrlLocale("lower"));
                if (translation) {
                    tag.value = translation.value.trim().replace(/^<>/, "");
                }
            }
            return (_jsx(Tag, { cssClass: tag.cssClass, title: tag.value, cssstyles: tag.cssStyles }, tag.key));
        }) }));
};
export default TagsGroup;
